import {BasicWriter} from "./Writer"
import {Register} from "../../genes/Register"

export const Writer4 = Register.global("$hxClasses")["tink.json.Writer4"] = 
class Writer4 extends Register.inherits(BasicWriter) {
	new() {
		super.new();
	}
	process0(value) {
		let __first = true;
		this.buf += String.fromCodePoint(123);
		let value1 = value._13;
		if (__first) {
			__first = false;
		} else {
			this.buf += String.fromCodePoint(44);
		};
		this.buf += "\"mime\":";
		let s = JSON.stringify(value1);
		this.buf += s;
		this.buf += String.fromCodePoint(125);
	}
	write(value) {
		this.init();
		this.process0(value);
		return this.buf.toString();
	}
	static get __name__() {
		return "tink.json.Writer4"
	}
	static get __super__() {
		return BasicWriter
	}
	get __class__() {
		return Writer4
	}
}

